/**
 * Feature announcement registry.
 *
 * Each entry describes one toast that may be shown to EXISTING users
 * (those who visited tradermap.io before the feature shipped). New
 * visitors never see these — they have no reference for what's new.
 *
 * # Adding a new announcement
 *
 * 1. Append an entry below with a unique `id`.
 * 2. Add i18n keys in all four locales under `toast.<id>.{title,body,cta}`
 *    (en/ru/ko/zh.json).
 * 3. Create a PostHog feature flag named `<flag>` (default off; toggle on
 *    when ready to broadcast). Optionally target a rollout %.
 * 4. Deploy. Existing users who haven't dismissed will see the toast
 *    once the PostHog flag flips on; they can dismiss with × or by
 *    clicking the CTA (either way it never reappears for them).
 *
 * # Stacking order
 *
 * Only the FIRST applicable (flag on AND not dismissed) announcement
 * renders at a time. Order in this array == priority — newest at the
 * top, please. Once a user dismisses one, the next eligible one (if
 * any) becomes visible on the following pageview.
 *
 * # Removing
 *
 * Once a feature is "old news", flip the PostHog flag off (instant) and
 * delete the entry on next cleanup pass. Locale keys can stay until
 * the next i18n sweep.
 */

const ANNOUNCEMENTS = [
  {
    id: 'chart-cockpit',
    flag: 'chart-cockpit-announcement',
    path: '/chart',
    i18nKey: 'chartCockpit',
  },
  {
    id: 'liqmap',
    // PostHog feature flag — toggle on/off / rollout % in dashboard.
    flag: 'liqmap-announcement',
    // Route the CTA navigates to (passed through localizedPath so /en/...
    // /ru/... etc. routing works on locale subpaths).
    path: '/liquidation-map',
    // i18n namespace under `toast.<i18nKey>.{title,body,cta}`.
    i18nKey: 'liqmap',
  },
  // Example for the next launch — uncomment, fill out, then create the
  // PostHog flag `ai-trader-v2-announcement`:
  //
  // {
  //   id: 'ai-trader-v2',
  //   flag: 'ai-trader-v2-announcement',
  //   path: '/ai-trader',
  //   i18nKey: 'aiTraderV2',
  // },
];

export default ANNOUNCEMENTS;
